import {
    SET_AMENITY_LOADING,
    REMOVE_AMENITY_LOADING,
    GET_AMENITY,
    SET_AMENITY_FIELDS
} from "../types";

const initialState = {
    reactAPI: true, // This serves the purpose of differentia from React and Blade Server side.
    loading: false, // Initit loading state
    amenityData: {},
    amenityFields: {},
    oldValue: ""
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_AMENITY_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_AMENITY_LOADING:
            return {
                ...state,
                loading: false
            };
        case GET_AMENITY:
            return {
                ...state,
                amenityData: { ...payload }
            };
        case SET_AMENITY_FIELDS:
            return {
                ...state,
                amenityFields: { ...payload }
            };
        default:
            return state;
    }
}